export default {
  show ({ state }, payload) {
    state.vm.$root.$bvToast.toast(payload.content, {
      title: payload.title,
      autoHideDelay: 2000,
      variant: payload.variant || 'success',
      solid: true
    })
  }
}
